export default "__VITE_ASSET__DggV_IxT__"